window.addEventListener('load', function (event) {
  const productContainers = document.querySelectorAll('[data-product_card]');
  if (!productContainers || !productContainers.length) return;
  productContainers.forEach(container => {
    const variantsSelect = container.querySelector('select[data-variants]');
    if (!variantsSelect) return;
    initVariantSelector(variantsSelect, container);
    variantsSelect.parentElement.removeChild(variantsSelect);
  });
  /* const variantsSelect = document.querySelectorAll('select[data-variants]');
  if (!variantsSelect || !variantsSelect.length) return;
  variantsSelect.forEach((selector) => {
    initVariantSelector(selector);
    selector.parentElement.removeChild(selector);
  }); */
});

function initVariantSelector(selector, container) {
  const productVariants = [];
  // todo: add property for outputs only
  for (const option of selector.options) {
    const variantInfo = {
      id: option.value,
      values: option.dataset.values,
      url: option.dataset.url,
      raw_price: option.dataset.raw_price,
      price: option.dataset.price,
      raw_compare_at_price: option.dataset.raw_compare_at_price,
      compare_at_price: option.dataset.compare_at_price,
      unit_price: option.dataset.unit_price,
      options: option.dataset.values.split('|'),
      available: option.dataset.hasOwnProperty('available'),
      availability: option.dataset.availability,
    };
    productVariants.push(variantInfo);
  }

  //const productId = selector.dataset.variants;
  const productId = container.dataset.product_card;
  if (!productId) return;
  const productForm = container.querySelector(`form[data-product_form='${productId}']`);
  const productOptions = container.querySelectorAll(`[data-variant_options='${productId}']`);
  //const container = document.querySelector(`[data-product_card='${productId}']`);
  const productPrice = container.querySelector("[data-output='price']");
  const productCompareAtPrice = container.querySelector("[data-output='compare_at_price']");
  const productUnitPrice = container.querySelector("[data-output='unit_price']");
  const sellingPlanInput = productForm.querySelector("input[name='selling_plan']");
  const variantInput = productForm.querySelector("input[name='id']");
  if (productOptions.length) {
    const convertCurrencyEvent = new CustomEvent('CurrencyConverterUpdate', {
      detail: { outputs: [productPrice, productCompareAtPrice] },
    });
    const variantUpdateEvent = new CustomEvent('ProductVariantUpdate', { detail: { variant: variantInput } });
    productOptions.forEach((option) => {
      const isImagesTrigger = option.dataset.hasOwnProperty('variantImagesTrigger');
      const isFamilyTrigger = option.dataset.hasOwnProperty('variantFamilyTrigger');
      const values = option.querySelectorAll('[data-value]');
      values.forEach((value) => {
        value.addEventListener('click', function () {
          if (value.dataset.hasOwnProperty('selected')) return;
          if (isFamilyTrigger) return;
          const current = option.querySelector('[data-selected]');
          if (current) current.removeAttribute('data-selected');
          value.dataset.selected = true;
          option.dataset.option_value = value.dataset.value;
          const selected = updateVariant(productOptions, productVariants, productForm, container);
          toggleForm(productForm, selected ? selected.available : false);
          if (isImagesTrigger)
            filterVariantImages(
              option.dataset.variant_options.toLowerCase(),
              option.dataset.option_value.toLowerCase()
            );
          if (selected) {
            productPrice.dataset.money = selected.raw_price;
            if (productCompareAtPrice) {
              if (productCompareAtPrice.dataset.hasOwnProperty('active_class')) {
                const activeClass = productCompareAtPrice.dataset.active_class;
                if (selected.raw_compare_at_price && !productCompareAtPrice.classList.contains(activeClass))
                  productCompareAtPrice.classList.add(activeClass);
                if (!selected.raw_compare_at_price) productCompareAtPrice.classList.remove(activeClass);
              }
              productCompareAtPrice.dataset.money = selected.raw_compare_at_price;
            }
            document.body.dispatchEvent(convertCurrencyEvent);
            document.body.dispatchEvent(variantUpdateEvent);
          }
        });
      });
      if (isImagesTrigger) {
        window.addEventListener('load', function () {
          filterVariantImages(option.dataset.variant_options.toLowerCase(), option.dataset.option_value.toLowerCase());
        });
      }
    });
    // handle media slider
    updateMediaGallery(productId, variantInput.value);
    // trigger variant images on load
    document.body.dispatchEvent(variantUpdateEvent);
  }
}

function updateVariant(options, variants, form, container) {
  const selectedOptions = [];
  options.forEach((option) => {
    selectedOptions.push(option.dataset.option_value);
  });
  const selectedVariant = variants.find((variant) => variant.values === selectedOptions.join('|'));

  if (!selectedVariant) return false;

  // var event = new CustomEvent('OrdersifyFormChange', { detail: { variantID: selectedVariant.id } });
  // document.body.dispatchEvent(event);
  const variantInput = form.querySelector("input[name='id']");
  if (variantInput) variantInput.value = selectedVariant.id;
  const sellingPlanInput = form.querySelector("input[name='selling_plan']");
  const requestedUrl = new URL(window.location.href);
  //if (requestedUrl.pathname.includes('products'))
  if (container.dataset.hasOwnProperty('main_product'))
    updateProductUrl(variantInput.value, sellingPlanInput ? sellingPlanInput.value : null);
  /* 
  const outputParent = document.querySelector(`[data-product_card='${form.dataset.product_form}']`);
  const variantOutput = outputParent
    ? outputParent.querySelectorAll('[data-output]')
    : document.querySelectorAll('[data-output]'); 
  */
 const variantOutput = container.querySelectorAll('[data-output]'); 
  variantOutput.forEach((output) => {
    if (output.dataset.output === 'images') {
      const updated = output.querySelector(`.variant-image.variant-${selectedVariant.id}`);
      if (updated) {
        const current = output.querySelector('[data-active]');
        if (current) {
          current.removeAttribute('data-active');
        }
        updated.dataset.active = true;
      }
    } else if (output.dataset.output === 'url') {
      // replace target url on product card
      output.href = selectedVariant[output.dataset.output];
    } else if (output.dataset.output === 'availability') {
      // replace availability status label on product page
      output.textContent = selectedVariant[output.dataset.output];
      output.removeAttribute('data-hidden');
      if (!selectedVariant[output.dataset.output]) {
        output.dataset.hidden = '';
      }
    } else {
      const outputPrefix = output.dataset.hasOwnProperty('prefix') ? output.dataset.prefix : '';
      const outputSuffix = output.dataset.hasOwnProperty('suffix') ? output.dataset.suffix : '';
      const outputText = outputPrefix + selectedVariant[output.dataset.output] + outputSuffix;
      output.textContent = outputText;
    }
  });
  // handle media slider
  updateMediaGallery(form.dataset.product_form, selectedVariant.id);

  return selectedVariant;
}

function toggleForm(form, isAvailable) {
  const submit = form.querySelector('[data-submit]');
  if (!submit) return;
  /*
  - !isAvailable && submit.disabled = nothing happens
  - !isAvailable && !submit.disabled = toggle submit button to disabled
  - isAvailable && !submit.disabled = nothing happens
  - isAvailable && submit.disabled = toggle submit button to enabled
  */
  if ((isAvailable && !submit.disabled) || (!isAvailable && submit.disabled)) return;
  const notSubmit = !submit.disabled;
  submit.disabled = notSubmit;
}

function formatSelectOptionsText(options, current, prepend, append) {
  for (const option of options) {
    if (option.index === current) {
      if (prepend) option.text = prepend + option.text;
      if (append) option.text = option.text + append;
    } else {
      if (prepend) option.text = option.text.replace(prepend, '');
      if (append) option.text = option.text.replace(append, '');
    }
  }
}

function filterVariantImages(option, value) {
  $('[data-variant-images]').slick('slickUnfilter');
  $('[data-variant-images]').slick('slickFilter', `.${option}-${value}, .options-all`);
}

function updateMediaGallery(productId, variantId) {
  const mediaSlider = document.querySelector(`[data-product_media_slider='${productId}']`);
  if (mediaSlider) {
    const swiperInstance = mediaSlider.swiper;
    const selectedMedia = mediaSlider.querySelector(`.swiper-slide.variant-${variantId}`);
    const selectedIndex = selectedMedia ? parseInt(selectedMedia.dataset.slide_index) : null;
    if (selectedIndex || selectedIndex === 0) {
      swiperInstance.slideTo(selectedIndex);
    }
  }
}

/* const quantityInput = document.querySelector("div[data-input='quantity']");
if (quantityInput) {
  const productQuantity = document.querySelector("input[name='quantity']");
  initQuantityInput(quantityInput, function (input, value) {
    productQuantity.value = value;
  });
} */
